/* eslint-disable max-len */
import {
  PO_DETAILS_LIST,
  ADD_EDIT_PO_DETAILS,
  PO_DETAILS_CLIENTS,
  BULK_UPDATE_PO_STATUS,
  DELETE_PO_DETAILS,
} from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const getPODetailsListRequest = (params = {}) => {
  const parts = [];
  Object.keys(params || {}).forEach((key) => {
    const val = params[key];
    if (val === '' || val === null || val === undefined) return;
    if (Array.isArray(val)) {
      val.forEach((value) => parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`));
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
    }
  });
  const queryString = parts.join('&');

  return {
    url: PO_DETAILS_LIST + (queryString ? `?${queryString}` : ''),
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getPODetailsById = (poId) => {
  return {
    url: `${PO_DETAILS_LIST}/${poId}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const createPODetails = (poData) => {
  return {
    url: ADD_EDIT_PO_DETAILS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: poData,
    service: serviceName.MASTER_MS,
  };
};

export const updatePODetails = (poId, poData) => {
  return {
    url: `${ADD_EDIT_PO_DETAILS}/${poId}`,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: poData,
    service: serviceName.MASTER_MS,
  };
};

export const bulkUpdatePOStatusRequest = (poIds, newStatus) => {
  return {
    url: BULK_UPDATE_PO_STATUS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: {
      po_ids: poIds,
      po_status: newStatus,
    },
    service: serviceName.MASTER_MS,
  };
};

export const deletePODetailsRequest = (poId) => {
  return {
    url: `${DELETE_PO_DETAILS}/${poId}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getClientsListRequest = () => {
  return {
    url: PO_DETAILS_CLIENTS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
